<template>
  <div id="brave-app" :class="[{ nowrap: nowrap() }]" :data-brand="siteBrand" :data-section="section">
    <component :is="headerComponent" :class="{ bare: bare() }" />

    <transition name="fade">
      <router-view :key="$route.fullPath" />
    </transition>

    <brave-modal v-for="({component, props}, index) in modals" :key="component.name" :component="component" :props="props" />
    <shared-footer :class="{ collapse: bare() }" />
    <transition name="fade">
      <cookie-message v-if="showCookieMessage" v-show="showCookieMessage" @close="handleCloseCookieMessage" ref="cookieMessage" />
    </transition>
  </div>
</template>

<script>
import {mapMutations, mapState} from 'vuex'
import header from 'components/shared-header'
import siteBlocksHeader from 'components/siteblocks-header'
import footer from 'components/shared-footer'
import modal from 'brave-routing/components/brave-modal'
import cookieMessage from 'components/cookie-message'
import {SITEBLOCKS_HEADER_ROUTE_WHITELIST} from "../app-constants";

export default {
  name: 'brave-app',
  data() {
    return {
      showCookieMessage: !localStorage.getItem('gdpr_opt_in_capturing'), // Check localStorage directly
    }
  },
  mounted() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");
    if (window.navigator.userAgent !== 'PRERENDER') {
      document.body.classList.add('enable-animations');
    }
    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
      document.body.classList.add('is-ie')
    }

    setTimeout(() => {
      this.$refs.cookieMessage.hideCookie = false; // Remove the 'hide-cookie' class after 10 seconds
    }, 10000);

    // console.log('route', this.$route);
    // console.log('Current Route', this.getCurrentRoute());
    // console.log('siteblocks_header_route_whitelist', SITEBLOCKS_HEADER_ROUTE_WHITELIST);
  },
  computed: {
    ...mapState([
      'modals'
    ]),
    headerComponent() {
      if (SITEBLOCKS_HEADER_ROUTE_WHITELIST.includes(this.getCurrentRoute())
          && (this.$route.query.brand === 'siteblocks' || this.$route.query.from === 'siteblocks')) {
        return 'siteblocks-header';
      }
      return 'shared-header';
    },
    siteBrand() {
      if (this.$route.query.brand === 'siteblocks' || this.$route.query.from === 'siteblocks') {
        return 'siteblocks';
      } else {
        return 'bravenet';
      }
    },
    section() {
      // Use getCurrentRoute() to get the modified path
      return this.getCurrentRoute();
    }
  },
  watch: {
    '$route'() {
      this.updateTitle()
    }
  },
  methods: {
    getCurrentRoute() {
      let currentFullPath = this.$route.fullPath.slice(1); // Remove leading slash
      if (currentFullPath === '/' || currentFullPath === '') {
        currentFullPath = 'home';
      }
      // Split the path at the first question mark to remove query parameters
      const pathWithoutQuery = currentFullPath.split('?')[0];
      const modifiedPath = pathWithoutQuery.replace(/\//g, '-'); // Replace / with -
      // Check for the specific case 'sitebuilder-templates' and return 'sitebuilder'
      if (modifiedPath === 'sitebuilder-templates') {
        return 'sitebuilder';
      }
      return modifiedPath;
    },
    handleCloseCookieMessage() { // This method will be called when the 'close' event is emitted
      this.showCookieMessage = false; // Hide the cookie-message component
    },
    getCookie(name) {
      // const value = `; ${document.cookie}`;
      // const parts = value.split(`; ${name}=`);
      // if (parts.length === 2) return parts.pop().split(';').shift();
      localStorage.getItem('gdpr_opt_in_capturing')
    },
    ...mapMutations([
      'INCREMENT',
    ]),
    bare() {
      let barePaths = [
        '/register',
        '/login',
        '/lostpassword'
      ]

      return (barePaths.includes(this.$route.path))

    },
    nowrap() {
      let noWrapPaths = [
        /\/register\?nowrap/,
        /\/login\?nowrap/,
        /\/lostpassword\?nowrap/
      ]

      return (noWrapPaths.some(rx => rx.test(this.$route.fullPath)))

    },
    updateTitle() {
      document.title = this.$route.meta.title
      document.querySelector('meta[name="description"]').setAttribute("content", this.$route.meta.description)
      document.querySelector('meta[name="keywords"]').setAttribute("content", this.$route.meta.keywords)

    },
  },
  components: {
    'cookie-message': cookieMessage,
    'shared-header': header,
    'siteblocks-header': siteBlocksHeader,
    'shared-footer': footer,
    'brave-modal': modal
  },
}
</script>

<style>

.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: .2s;
}

.fade-enter-active {
  transition-delay: .2s;
}

.fade-enter, .fade-leave-active {
  opacity: 0
}

[v-cloak] {
  display: none;
}
.hide-cookie {
  display: block;
  visibility: hidden;
}
</style>


// WEBPACK FOOTER //
// apps/www.bravenet.com/src/components/main-component.vue